function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      color: "white"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    points: "28.744,10.696 16,20.3 3.15,10.616 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94a3b8",
      stroke: "#94a3b8",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M9,7.781V26H5c-1.105,0-2-0.895-2-2V9 c0-1.657,1.343-3,3-3l0,0c0.678,0,1.308,0.221,1.81,0.6L16,12.77l8.19-6.17C24.691,6.226,25.327,6,26,6l0,0c1.657,0,3,1.343,3,3v15 c0,1.105-0.895,2-2,2h-4V7.673"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.93ec344a7dfcc7948f93f8901cd2376b.svg";
export { ForwardRef as ReactComponent };